// extracted by mini-css-extract-plugin
export var chip = "_ea-0";
export var filterDropdown = "_ea-5";
export var filterItem = "_ea-6";
export var icon = "_ea-1";
export var removeButton = "_ea-3";
export var removeIcon = "_ea-4";
export var separator = "_ea-2";